import React from 'react';
import { Copyright } from '@mui/icons-material';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="footer-title">SUGI - Sistema Único Gestión Integral</p>
        <p className="footer-copyright">
          <Copyright sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'middle' }} />
          2025 - NeuroSueño.com
        </p>
      </div>
    </footer>
  );
};

export default Footer;
